require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-google-places-api-and-swift.json") })
        }
      }, "path---blog-google-places-api-and-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-google-places-api-and-swift!./.cache/json/blog-google-places-api-and-swift.json
// module id = 822
// module chunks = 231608221292675